import { render, staticRenderFns } from "./SimpleVideoItem.vue?vue&type=template&id=7e8f4656&scoped=true&"
import script from "./SimpleVideoItem.vue?vue&type=script&lang=js&"
export * from "./SimpleVideoItem.vue?vue&type=script&lang=js&"
import style0 from "./SimpleVideoItem.vue?vue&type=style&index=0&id=7e8f4656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8f4656",
  null
  
)

export default component.exports